<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Data</th>
          <th>Hora</th>
          <th>Status</th>
          <th>Profissional</th>
          <th>Unidade</th>
          <th>Especialidade</th>
          <th>Guia</th>
          <th>Excluir</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="agendamento in agendamentos" :key="agendamento._id">
          <td>{{ formatarData(agendamento.data, 'DD/MM/YYYY') }}</td>
          <td>{{ agendamento.hora }}</td>
          <td
            :class="
              'status_agendamento agendamento-legenda-item--' +
              agendamento.status
            "
            >{{ agendamento.status }}</td
          >
          <td>{{ agendamento.profissional.nome }}</td>
          <td>{{ agendamento.unidade }}</td>
          <td>{{ agendamento.especialidade }}</td>
          <td>
            <button
              data-test-id="button-exibiralertavalores-1"
              class="btn btn-xs btn-link"
              @click="
                exibirAlertaValores(
                  'Guias',
                  agendamento.guia,
                  ['numero', 'especialidade'],
                  ['Número', 'Especialidade']
                )
              "
            >
              Ver todas
            </button>
          </td>
          <td>
            <button
              id="botaoLimpar"
              v-tooltip.bottom="'Excluir agendamento'"
              data-test-id="button-botaolimpar"
              name="botaoLimpar"
              type="button"
              class="btn btn-xs btn-link"
              @click="deletar(agendamento)"
            >
              <span class="fa fa-trash" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import * as formatadores from '@/utils/formatadores'
const agendamentoServico = new AgendamentoServico()
export default {
  name: 'PacienteAgendamentosTabela',
  mixins: [alertaMixin],
  props: {
    agendamentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    deletar(agendamento) {
      agendamentoServico.remover(agendamento._id).then((res) => {
        this.$emit('atualizar')
      })
    },
  },
}
</script>

<style scoped>
.status_agendamento {
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
